import { Injectable } from '@angular/core';
import { URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ConstantsService } from './../../services/constants-service';
import { ObservableRequestService } from './../../services/observable-request.service';

/**
 * Service for archival related calls.
 *
 * @author mohit.khurana@vernuso.com (Mohit Khurana)
 */
@Injectable()
export class ArchivalService {
    constructor(private requestService: ObservableRequestService) { }

    findEntitiesWithoutRelations(
        withScreeningHitsOnly: boolean,
        withNoDocumentsOnly: boolean): Observable<any> {
        const params = new URLSearchParams();
        if (withScreeningHitsOnly) {
            params.set('withScreeningHitsOnly', 'true');
        }
        if (withNoDocumentsOnly) {
            params.set('withNoDocumentsOnly', 'true');
        }
        return this.requestService.getRequest(
            ConstantsService.ENTITIES_WITHOUT_RELATIONS_URL,
            params);
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/archival/archival.service.ts